import EnvVar from '../../ts/types/EnvVar.type';
import useEnvVar from '../useEnvVar';

const useIsFeatureFlagEnabled = (envVar: EnvVar) => {
  const value = useEnvVar(envVar);
  return value === 'true';
};

export default useIsFeatureFlagEnabled;
